import { Navigate, Outlet } from 'react-router-dom';
import styled from 'styled-components';
import Header from '../widgets/Header';
import { SidebarProvider } from 'layouts/SidebarLayout/SidebarContext';
import storage from 'utils/sessionStorage';

const PrivateLayout = () => {
  const token = storage.token.get();
  if (!token) return <Navigate to={'/login'} replace />;
  return (
    <SidebarProvider>
      <Container>
        <Header />
        <Outlet />
      </Container>
    </SidebarProvider>
  );
};

export default PrivateLayout;

const Container = styled.div`
display: flex;
flex-direction: column;
height: 100vh;
`;